import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import {ShellConstant} from '@shell_components/constants/shellConstants';
import { SharedService } from '@ems/shared';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss']
})
export class UnauthorizedComponent implements OnInit {

  shellConstant = ShellConstant;
  hideUnauthorized: Observable<boolean>;
  accessDenied: Observable<boolean>;
  constructor(public sharedService: SharedService, private router: Router, private changeDetectorRef: ChangeDetectorRef) {
    /* Handled Unauthorized Page for InitialLoad/Request Error Scenarios */
   
  }

  ngOnInit() {
    this.hideUnauthorized = this.sharedService.requestFailureStatus$;
    this.accessDenied = this.sharedService.accessDeniedStatus$;
   }



}
